export const enum AppRoutes {
    INDEX = "/",
    AUTH = "/auth",
    ADMIN = "/admin",
    PROFILE = "/profile/:userNickname",
    GROUPS = "/groups",
    GROUP = "/groups/:groupId",
    GROUP_MEMBERS = "/groups/:groupId/members",
    GROUP_DUELS = "/groups/:groupId/duels",
    GROUP_TOURNAMENTS = "/groups/:groupId/tournaments",
    GROUP_TOURNAMENT = "/groups/:groupId/tournaments/:tournamentId",
    DUEL = "/duel/:duelId",
    DUEL_TASK_DESCRIPTION = "/duel/:duelId/description",
    DUEL_TASK_SUBMISSIONS = "/duel/:duelId/submissions",
    DUEL_TASK_SUBMISSION_CODE = "/duel/:duelId/submissions/:submissionId",
}
